"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URI = /** @class */ (function () {
    function URI(decl) {
        this.scheme = decl.scheme || 'http';
        this.host = decl.host;
        this.port = decl.port || (decl.scheme === 'https' ? 443 : 80);
        this.path = decl.path;
        this.query = decl.query || '';
    }
    URI.prototype.toString = function () {
        return stringifyURI(this);
    };
    return URI;
}());
exports.URI = URI;
function normalizeURI(decl) {
    return new URI(decl);
}
exports.normalizeURI = normalizeURI;
function stringifyURI(uri) {
    var portIsStandard = (uri.scheme === 'https' && uri.port === 443) || (uri.scheme === 'http' && uri.port === 80);
    var portFragment = portIsStandard ? '' : ':' + String(uri.port);
    var hostFragment = uri.host + portFragment;
    var schemeFragment = uri.scheme + "://";
    var pathFragment = uri.path === '' ? '/' : uri.path;
    var searchFragment = uri.query === '' ? '' : '?' + uri.query;
    return schemeFragment + hostFragment + pathFragment + searchFragment;
}
exports.stringifyURI = stringifyURI;
function invariant(statement, message) {
    if (!statement) {
        throw new Error(message);
    }
}
function firstPositive() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0; i < args.length; i++) {
        var x = args[i];
        if (x >= 0) {
            return x;
        }
    }
    return 0;
}
function parseURI(uri) {
    var processedUri = uri;
    var schemeEndIndex = uri.indexOf('://');
    invariant(schemeEndIndex >= 0, 'Unable to parse scheme');
    var scheme = processedUri.slice(0, schemeEndIndex);
    processedUri = processedUri.slice(schemeEndIndex + 3);
    invariant(scheme === 'http' || scheme === 'https', "Unknown scheme '" + scheme + "'");
    var atIndex = processedUri.indexOf('@');
    var colonIndex = processedUri.indexOf(':');
    if (colonIndex >= 0 && colonIndex < atIndex) {
        var sliceLength = colonIndex + 1;
        processedUri = processedUri.slice(sliceLength);
        atIndex -= sliceLength;
    }
    colonIndex = processedUri.indexOf(':');
    if (colonIndex >= 0) {
        invariant(colonIndex > atIndex, "Invalid uri '" + uri + "'");
    }
    var slashIndex = processedUri.indexOf('/');
    if (slashIndex >= 0) {
        invariant(slashIndex > atIndex && slashIndex > colonIndex, "Invalid uri '" + uri + "'");
    }
    var questionMarkIndex = processedUri.indexOf('?');
    if (questionMarkIndex >= 0) {
        invariant(questionMarkIndex > atIndex && questionMarkIndex > colonIndex && questionMarkIndex > slashIndex, "Invalid uri '" + uri + "'");
    }
    var hashIndex = processedUri.indexOf('#');
    if (hashIndex >= 0) {
        invariant(hashIndex > atIndex && hashIndex > colonIndex && hashIndex > slashIndex && hashIndex > questionMarkIndex, "Invalid uri '" + uri + "'");
    }
    if (atIndex >= 0) {
        var sliceLength = atIndex + 1;
        processedUri.slice(0, atIndex);
        processedUri = processedUri.slice(sliceLength);
        colonIndex -= sliceLength;
        slashIndex -= sliceLength;
        questionMarkIndex -= sliceLength;
        hashIndex -= sliceLength;
    }
    var host = '';
    {
        var sliceLength = firstPositive(colonIndex, slashIndex, questionMarkIndex, hashIndex, processedUri.length);
        invariant(sliceLength > 0, "Invalid uri '" + uri + "'");
        host = processedUri.slice(0, sliceLength);
        processedUri = processedUri.slice(sliceLength);
        colonIndex -= sliceLength;
        slashIndex -= sliceLength;
        questionMarkIndex -= sliceLength;
        hashIndex -= sliceLength;
    }
    var port = scheme === 'http' ? 80 : 443;
    if (colonIndex === 0) {
        var sliceLength = firstPositive(slashIndex, questionMarkIndex, hashIndex, processedUri.length);
        var stringPort = processedUri.slice(1, sliceLength);
        port = parseInt(stringPort, 10);
        invariant(String(port) === stringPort, "Invalid port '" + stringPort + "'");
        processedUri = processedUri.slice(sliceLength);
        slashIndex -= sliceLength;
        questionMarkIndex -= sliceLength;
        hashIndex -= sliceLength;
    }
    var path = '/';
    {
        var sliceLength = firstPositive(questionMarkIndex, hashIndex, processedUri.length);
        if (sliceLength > 0) {
            path = processedUri.slice(0, sliceLength);
            processedUri = processedUri.slice(sliceLength);
            questionMarkIndex -= sliceLength;
            hashIndex -= sliceLength;
        }
    }
    var query = '';
    {
        var sliceLength = firstPositive(hashIndex, processedUri.length);
        query = processedUri.slice(1, sliceLength);
    }
    return {
        host: host,
        path: path,
        port: port,
        query: query,
        scheme: scheme,
    };
}
exports.parseURI = parseURI;
function mergeBaseUriPiece(baseUriPiece, extensionPiece) {
    if (typeof extensionPiece === 'undefined') {
        return baseUriPiece;
    }
    if (typeof extensionPiece === 'function') {
        return extensionPiece(baseUriPiece);
    }
    return extensionPiece;
}
function mergeBaseUri(baseUri, extension) {
    var parsedBaseUri = parseURI(baseUri);
    var scheme = mergeBaseUriPiece(parsedBaseUri.scheme, extension.scheme);
    var host = mergeBaseUriPiece(parsedBaseUri.host, extension.host);
    var port = mergeBaseUriPiece(parsedBaseUri.port, extension.port);
    var path = mergeBaseUriPiece(parsedBaseUri.path, extension.path);
    var query = mergeBaseUriPiece(parsedBaseUri.query, extension.query);
    return {
        host: host,
        path: path,
        port: port,
        query: query,
        scheme: scheme,
    };
}
exports.mergeBaseUri = mergeBaseUri;
function mergePaths(left, right) {
    var leftSlash = left[left.length - 1] === '/';
    var rightSlash = right[0] === '/';
    if (leftSlash && rightSlash) {
        return left + right.slice(1);
    }
    if (!leftSlash && !rightSlash) {
        return left + "/" + right;
    }
    return left + right;
}
exports.mergePaths = mergePaths;
//# sourceMappingURL=uri.js.map